import {
  LanguageId,
  useArticleTranslationPublishMutation,
} from 'lib-knowledge-management-common/graphql';
import { ampli } from 'lib-shared-tracking';

type MutationFunction = ReturnType<
  typeof useArticleTranslationPublishMutation
>[0];
type MutationReturnValue = ReturnType<MutationFunction>;

export type TranslationPublishFn = () => MutationReturnValue;

type UseArticleTranslationPublishReturnValue = [
  TranslationPublishFn,
  ReturnType<typeof useArticleTranslationPublishMutation>[1],
];

type UseArticleTranslationPublishOptions = {
  articleId: string;
  languageId: LanguageId;
};

export function useArticleTranslationPublish({
  articleId,
  languageId,
}: UseArticleTranslationPublishOptions): UseArticleTranslationPublishReturnValue {
  const [publishFn, mutationResult] = useArticleTranslationPublishMutation();

  const publish: TranslationPublishFn = async () => {
    return publishFn({
      variables: {
        articleId,
        languageId,
      },
      refetchQueries: ['ArticleTranslation'],
    }).then((args) => {
      ampli.knowledgeArticlePublished({ articleId });
      return args;
    });
  };

  return [publish, mutationResult];
}
